import ministryService from "../../../../services";
export default {
  namespaced: true,
  state: () => {
    return {
      working: false,
    };
  },
  getters: {
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async editNgo({ commit }, payload) {
      commit("setWorking", true);
      try {
        await ministryService.updateNgo(payload);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async addNgo({ commit }, payload) {
      commit("setWorking", true);
      try {
        await ministryService.addNgo(payload);
      } catch (err) {
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteNgo({ commit }, id) {
      try {
        await ministryService.deleteNgo(id);
      } catch (err) {
      } finally {
      }
    },
  },
};
